export default group => {
  if (group === 'Admin') return '/'
  // For now this redirects to the same page. In the future we will likely implement different home routes for different users.
  if (group === 'Builder') return { name: 'permissions' }
  return { name: 'login' }
}
